import { Injectable, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { splEnvironment } from '@splitory/splitory-environment';
import { SplHttpResponse } from '../../types';

@Injectable()
export class SplHttpBaseService {
  private readonly httpClient = inject(HttpClient);

  protected baseEndpoint = '';

  private readonly pathPrefix = computed(
    () =>
      `${[splEnvironment.origin.api, splEnvironment.api.globalPrefix, this.baseEndpoint].filter(Boolean).join('/')}/`,
  );

  protected get<D, M = undefined>(path: string): Observable<SplHttpResponse<D, M>> {
    return this.httpClient.get<SplHttpResponse<D, M>>(`${this.pathPrefix()}${path}`, {
      withCredentials: true,
    });
  }

  protected post<D, M = undefined>(path: string): Observable<SplHttpResponse<D, M>> {
    return this.httpClient.post<SplHttpResponse<D, M>>(`${this.pathPrefix()}${path}`, null, {
      withCredentials: true,
    });
  }

  protected put<D, M = undefined>(path: string): Observable<SplHttpResponse<D, M>> {
    return this.httpClient.put<SplHttpResponse<D, M>>(`${this.pathPrefix()}${path}`, null, {
      withCredentials: true,
    });
  }

  protected delete<D, M = undefined>(path: string): Observable<SplHttpResponse<D, M>> {
    return this.httpClient.delete<SplHttpResponse<D, M>>(`${this.pathPrefix()}${path}`, {
      withCredentials: true,
    });
  }
}
